const translations = {
  "payredirect.payment": "დავალიანების გადახდა",
  "payredirect.unoAcitve": "უნო აქტივი",
  "payredirect.saerto": "საერთო",
  "payredirect.pay": "გადახდა",
};

export default translations;
